import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { formatDate } from '../../helpers/custom';
import { Card, CardHeader, CardContent, CardActions, Grid, Typography, Button, FormControl, Select, MenuItem, ButtonGroup, Backdrop, CircularProgress, Modal, Box, IconButton, Divider, TextField } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import { withTranslation, WithTranslation } from 'react-i18next';
import { CloseOutlined, KeyboardArrowLeftRounded } from '@mui/icons-material';
import DiversionHeader from './DiversionHeader';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    duration: string;
    organicWasteDataBar: any;
    organicWasteBarChartOptions: any;
    recyclableWasteDataBar: any;
    recyclableWasteBarChartOptions: any;
    showCustomDateFilter: boolean;
    customFromDate?: string | null;
    customToDate?: string | null;
}

class DivertedWasteDetails extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            duration: 'month',
            organicWasteDataBar: {
                labels: [],
                datasets: [
                    {
                        label: 'Organic',
                        data: [],
                        backgroundColor: 'rgba(32, 77, 54, 1)',
                        // borderWidth: 2,
                        // borderColor: 'rgba(32, 77, 54, 1)'
                    }
                ]
            },
            organicWasteBarChartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top' as const,
                        rotate: '90'
                    },
                    title: {
                        display: true,
                        text: 'Organic Waste',
                    },
                    datalabels: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: true,
                            color: '#F8F8F8'
                        }
                    },
                    y: {
                        grid: {
                            display: true,
                            color: '#F8F8F8'
                        }
                    }
                }
            },
            recyclableWasteDataBar: {
                labels: [],
                datasets: [
                    {
                        label: 'Recyclable',
                        data: [],
                        backgroundColor: 'rgba(32, 77, 54, 1)',
                        // borderWidth: 2,
                        // borderColor: 'rgba(32, 77, 54, 1)'
                    }
                ]
            },
            recyclableWasteBarChartOptions: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top' as const,
                    },
                    title: {
                        display: true,
                        text: 'Recyclable Waste',
                    },
                    datalabels: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: true,
                            color: '#F8F8F8'
                        }
                    },
                    y: {
                        grid: {
                            display: true,
                            color: '#F8F8F8'
                        }
                    }
                }
            },
            showCustomDateFilter: false,
            customFromDate: null,
            customToDate: null
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
        this.fetchGraphData();
    }

    public fetchGraphData(filter: string = this.state.duration) {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let data: any = {
                'hierarchies': this.props.user.selectedHierarchyIds
            };
            if (filter == "custom") {
                data.start_date = (this.state.customFromDate) ? formatDate(this.state.customFromDate, 'Y-m-d') : "";
                data.end_date = (this.state.customToDate) ? formatDate(this.state.customToDate, 'Y-m-d') : "";
            } else {
                data.filter = filter
            }
            axios.post(`sortedWasteReport`, data).then((response: any) => {
                if (response.data.success) {
                    let data: any = response.data.data;
                    let organicWasteDataBar = this.state.organicWasteDataBar;
                    let recyclableWasteDataBar = this.state.recyclableWasteDataBar;
                    if (filter == 'today') {
                        organicWasteDataBar.labels = [formatDate(data.date.date, 'd/m/Y')];
                        organicWasteDataBar.datasets[0].data = data.sortedWasteOrganic;
                        recyclableWasteDataBar.labels = [formatDate(data.date.date, 'd/m/Y')];
                        recyclableWasteDataBar.datasets[0].data = data.sortedWasteRecycling;
                    } else if (filter == 'week') {
                        organicWasteDataBar.labels = data.dates;
                        organicWasteDataBar.datasets[0].data = data.sortedWasteOrganic;
                        recyclableWasteDataBar.labels = data.dates;
                        recyclableWasteDataBar.datasets[0].data = data.sortedWasteRecycling;
                    } else if (filter == 'month') {
                        organicWasteDataBar.labels = data.dates;
                        organicWasteDataBar.datasets[0].data = data.sortedWasteOrganic;
                        recyclableWasteDataBar.labels = data.dates;
                        recyclableWasteDataBar.datasets[0].data = data.sortedWasteRecycling;
                    } else {
                        organicWasteDataBar.labels = data.dates;
                        organicWasteDataBar.datasets[0].data = data.sortedWasteOrganic;
                        recyclableWasteDataBar.labels = data.dates;
                        recyclableWasteDataBar.datasets[0].data = data.sortedWasteRecycling;
                    }
                    this.setState({
                        showLoader: false,
                        organicWasteDataBar: organicWasteDataBar,
                        recyclableWasteDataBar: recyclableWasteDataBar,
                        showCustomDateFilter: false
                    });
                } else {
                    this.setState({ showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.setState({ showLoader: false });
            });
        }
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
<DiversionHeader user={this.props.user} />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                avatar={
                                    <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/diverted-waste'}><KeyboardArrowLeftRounded /></Button>
                                }
                                title={t("Diverted Waste")}
                                className="text-left"
                            />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Card sx={{ boxShadow: 3 }}>
                                            <CardHeader
                                                title={t("Material Flow Of Diverted Waste")}
                                                className="text-left"
                                                action={
                                                    <ButtonGroup variant="contained" className="diversionButtonGroup" aria-label="Material Flow of Diverted Waste button group">
                                                        <Button className={(this.state.duration == 'today') ? "active" : ""} onClick={() => { this.setState({ duration: 'today' }); this.fetchGraphData('today') }}>{t("Today")}</Button>
                                                        <Button className={(this.state.duration == 'week') ? "active" : ""} onClick={() => { this.setState({ duration: 'week' }); this.fetchGraphData('week') }}>{t("Week")}</Button>
                                                        <Button className={(this.state.duration == 'month') ? "active" : ""} onClick={() => { this.setState({ duration: 'month' }); this.fetchGraphData('month') }}>{t("Last Month")}</Button>
                                                        <Button className={(this.state.duration == 'custom') ? "active" : ""} onClick={() => { this.setState({ duration: 'custom', showCustomDateFilter: true }); }}>{t("Custom")}</Button>
                                                    </ButtonGroup>
                                                }
                                            />
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={12}>
                                                        <Bar data={this.state.organicWasteDataBar} options={this.state.organicWasteBarChartOptions} height={250} redraw={true} />
                                                    </Grid>
                                                    <Grid item md={6} xs={12}>
                                                        <Bar data={this.state.recyclableWasteDataBar} options={this.state.recyclableWasteBarChartOptions} height={250} redraw={true} />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showCustomDateFilter}
                    onClose={() => this.setState({ showCustomDateFilter: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Select Custom Analytics Dates")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showCustomDateFilter: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.customFromDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customFromDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("To Date") + " *"}
                                                    value={this.state.customToDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customToDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showCustomDateFilter: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.customFromDate || !this.state.customToDate} onClick={() => this.fetchGraphData()}>{t("Get Analytics")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(DivertedWasteDetails))